import * as bi from 'react-bootstrap-icons';
import { IClientTicketBrief } from '@bustickus/models-client';
import { Box, Button, Flex, TextContent } from 'components';
import { Icon, TicketStatus } from 'shared/components';
import { dateFormat } from 'common/helpers';
import './style.scss';
import { RoutingUrls } from 'common/const';

interface IProps {
  ticket: IClientTicketBrief;
}

function TicketCard(props: IProps) {
  const departureDate = dateFormat(props.ticket.departure?.departureDate, 'DD MMMM YYYY HH:mm');
  const arrivalDate = dateFormat(props.ticket.arrival?.arrivalDate, 'DD MMMM YYYY HH:mm');

  const handleTicketInfoClick = () => {
    const address = RoutingUrls.Ticket.replace(':ticketId', props.ticket.id);
    window.location.href = address;
  };

  return (
    <Box
      padding={20}
      className='ticket-card-5KRTb'
    >
      <Flex
        direction='column'
        gap={10}
      >
        <Flex
          gap={5}
          justifyContent='space-between'
          alignItems='flex-end'
        >
          <TicketStatus
            status={props.ticket.status}
            price={props.ticket.price}
          />
          <TextContent className='num-leva'>{props.ticket.number}</TextContent>
        </Flex>
        <Flex gap={5}>
          <Icon color='blue'>
            <bi.Person />
          </Icon>
          <b>{props.ticket.passengerName}</b>
        </Flex>
        <Flex gap={5}>
          <div>
            <Icon color='blue'>
              <bi.BusFront />
            </Icon>
          </div>
          <Flex direction='column'>
            <span>Номер рейса: {props.ticket.tripNumber}</span>
            <span className='carrier-name-7MHF'>{props.ticket.carrierName}</span>
          </Flex>
        </Flex>
        <Flex
          gap={5}
          direction='column'
          className='date-EyaE'
        >
          <Flex gap={5}>
            <div>
              <Icon color='blue'>
                <bi.Signpost />
              </Icon>
            </div>

            <Flex direction='column'>
              <span>
                <b>{props.ticket.departure?.cityName ?? 'N/A'}</b>
                <span className='city-p-vYDH'> — Отправление</span>
              </span>
              <Flex
                gap={5}
                className='date-w6PU'
              >
                <span>{departureDate.datetime}</span>
                <span className='timezone-s7qN'>({departureDate.mskTimezone})</span>
              </Flex>
            </Flex>
          </Flex>
          <Flex
            gap={5}
            className='date-EyaE'
          >
            <div>
              <Icon color='blue'>
                <bi.Signpost />
              </Icon>
            </div>

            <Flex direction='column'>
              <span>
                <b>{props.ticket.arrival?.cityName ?? 'N/A'}</b>
                <span className='city-p-vYDH'> — Прибытие</span>
              </span>
              <Flex
                gap={5}
                className='date-w6PU'
              >
                <span>{arrivalDate.datetime}</span>
                <span className='timezone-s7qN'>({arrivalDate.mskTimezone})</span>
              </Flex>
            </Flex>
          </Flex>
        </Flex>
        <Button
          color='red'
          size='small'
          onClick={handleTicketInfoClick}
        >
          <Flex
            gap={5}
            alignItems='center'
            justifyContent='center'
          >
            <span>Подробнее о билете</span>
          </Flex>
        </Button>
      </Flex>
    </Box>
  );
}

export default TicketCard;
